var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tuan"},[_c('img',{attrs:{"src":(_vm.$ossUrl + "tuan-optimization/tuanEnter.png"),"alt":""},on:{"click":_vm.handleTuan}})])}
var staticRenderFns = []

export { render, staticRenderFns }